import {ADMIN_C2C_WEBHOOK_URL} from '../configs/config';

/**
 * POSTs to USDI API `admin/c2c_webhook` (same host as other europe-west1 usdi-api routes).
 * Optional override: REACT_APP_ADMIN_C2C_WEBHOOK_URL (e.g. staging).
 * Payload: redeem-to-cash (C2C), large-amount mint/redeem (Squads / manual ops).
 */
export async function notifyAdminC2cRequest(payload) {
    const url = (
        (process.env.REACT_APP_ADMIN_C2C_WEBHOOK_URL || '').trim() || ADMIN_C2C_WEBHOOK_URL
    );

    try {
        await fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                event: 'c2c_redeem_request',
                sent_at: new Date().toISOString(),
                ...payload,
            }),
            keepalive: true,
        });
    } catch (e) {
        console.warn('notifyAdminC2cRequest:', e);
    }
}
